<template>
  <div>
    <h6
        v-if="commWith==='iona'"
    >
      IONA
      <small style="color: #222222"> Preview</small>
      <b-img
          v-bind="mainProps"
          rounded="circle"
          src="@/assets/iona/img/iona.png"
          alt="IONA (Insightful Omnipresent Nurturing Ant)"
      />
    </h6>
    <h6 v-else-if="commWith==='heartbeat'">
      <div v-if="selectedHeartBeat && false">
        💛  {{ selectedHeartBeat.name }}
        <b-avatar
            :src="selectedHeartBeat.imgURL"
            size="3rem"/>
      </div>
      <template v-if="true">
        <b-img
            v-if="false"
            v-bind="mainProps"
            rounded="circle"
            src="@/assets/heartbeat/img/heartbeat_on.png"
            alt="IONA (Insightful Omnipresent Nurturing Ant)"
        />
        <b-dropdown
            split
            split-variant="primary"
            variant="primary"
            class="m-2"
        >
          <template #button-content>
            {{ selectedHeartBeat ? selectedHeartBeat.name : 'Select HeartBeat'}}
          </template>
          <b-dropdown-item
              v-for="(aHeartbeat, hb) in heartbeats"
              @click="handleHeartBeatSelect(aHeartbeat)"
              :key="`hb_${hb}_chat`"
          >💛 {{ aHeartbeat.name }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </h6>
  </div>
</template>
<script>

export default {
  name: "Chat_SideBar_Title",
  components: {
  },
  props: {
    commWith: {
      type: String,
      required: true
    },
    heartbeats: {
      type: Array,
      required: true
    },
    selectedHeartBeat: {
      type: Object,
      default: null,
      required: false
    },
  },
  created() {

  },
  mounted() {},
  computed: {},
  methods: {
    handleHeartBeatSelect(heartBeat){
      if (this) {
        this.$emit('heartbeat-selected', heartBeat);
      }
    }

  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 40,
        height: 40,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
